import React from 'react';
import { Redirect } from 'react-router-dom';
import { LocationDescriptor } from 'history';

interface PushRedirectProps
{
	to: LocationDescriptor;
}

export function PushRedirect(props: PushRedirectProps)
{
	return <Redirect to={props.to} push={true} />;
}
